/**
 * Registry States
 */

import {Enum} from '@vendor/enumify/enumify';

/**
 * States for Registry
 * See docs: https://github.com/rauschma/enumify
 */
class State extends Enum {}

State.initEnum(['INIT', 'FAIL', 'LOADING', 'LOADED', 'REGISTERED', 'NOT_REQUIRED', 'CANCELLED']);

export default State;



// WEBPACK FOOTER //
// ./project/client/src/core/registry/state.js